var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "detView",
        title: "Update Part B",
        size: "lg",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("basic-e-w-b-details", { attrs: { ewaybill: _vm.ewaybill } }),
      _vm._v(" "),
      _c("h4", [_vm._v("Part B")]),
      _vm._v(" "),
      _c("form", [
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "vehicleNo" } }, [
                _vm._v("Vehicle Number")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.vehicleNo,
                    expression: "vehicleNo"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "vehicleNo" },
                domProps: { value: _vm.vehicleNo },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.vehicleNo = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "transhipmentLocation" } }, [
                _vm._v("Transhipment Location")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.transhipmentLocation,
                    expression: "transhipmentLocation"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "transhipmentLocation" },
                domProps: { value: _vm.transhipmentLocation },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.transhipmentLocation = $event.target.value
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.modal.isError
        ? _c("div", [
            _c(
              "div",
              { staticClass: "alert alert-danger", attrs: { role: "alert" } },
              [
                _vm._v(
                  "\n        Updating part B failed. " +
                    _vm._s(_vm.modal.errorMsg) +
                    "\n      "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modal.isSuccess
        ? _c("div", [
            _c(
              "div",
              { staticClass: "alert alert-success", attrs: { role: "alert" } },
              [_vm._v("\n        Part B updated.\n      ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modal.inProgress
        ? _c("div", [
            _c("div", { staticClass: "text-center" }, [
              _vm._v("\n        Updating Part B. Please wait...\n      ")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c("span", { staticClass: "fa fa-spinner fa-spin fa-3x" })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c("div", { staticClass: "float-right" }, [
            !_vm.modal.inProgress
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: {
                      click: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v("   Dismiss\n        ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.modal.isSuccess
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: {
                      click: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v("   Close\n        ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.modal.isSuccess
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { disabled: _vm.modal.inProgress },
                    on: {
                      click: function($event) {
                        return _vm.updatePartB(_vm.ewaybill)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-truck" }),
                    _vm._v("  Update PartB\n        ")
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a38f0ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a38f0ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/UpdatePartB.vue
// module id = null
// module chunks = 